import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ViewEncapsulation } from "@angular/core";
import { CclDrawerService, CclBuilderService, CclMessageService, CclNavbarFooterService } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-speaker-bio-page",
    templateUrl: "./speaker-bio-page.view.html",
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class SpeakerBioPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    speakerConfigObj: any;
    baseUrl = "";
    speakerConfig: any = {};
    basedOnImageName: any = {};
    ddfJson = "speaker-ddf.json";
    headerLayout: string;
    bodyLayout: string;
    fontstyle: any = {};

    ddfData: Array<any> = [];
    hover = false;
    templateStyles: any = {
        l_circular: "Layout w/ Circular Image",
        l_noimage: "Layout without Image",
        l_square: "Layout w/ Square Image",
        l_banner: "Layout w/ Banner Image"
    };
    speakerTemplateType: string;

    constructor(
        public sharedService: SharedService,
        private drawerService: CclDrawerService,
        public builderService: CclBuilderService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private activatedRoute: ActivatedRoute,
        private catalogService: CatalogService,
        private localDataService: LocalDataService
    ) {
        super(sharedService);
        if (this.activatedRoute.routeConfig.path === "highlighted-speaker") {
            this.speakerTemplateType = sharedService.catalogLayoutConfig.vipUnit;
            this.baseUrl = "highlighted";
            this.ddfJson = "speaker-ddf.json";
        } else if (this.activatedRoute.routeConfig.path === "speaker-sessions") {
            this.speakerTemplateType = sharedService.catalogLayoutConfig.listType;
            this.baseUrl = "general";
            this.ddfJson = "speaker-ddf.json";
        }

        sharedService.sessionUrl = this.baseUrl;
        this.localDataService.getJSON(this.ddfJson).subscribe((data) => {
            if (data != null) {
                this.ddfData = data;
            }

            if (this.sharedService.speakerCustomFields != null) {
                this.sharedService.speakerCustomFields.forEach((cf) => {
                    this.ddfData.push({
                        label: cf.name,
                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                        type: "Speaker custom field"
                    });
                });
            }

            this.headerLayout = this.getFormattedDDFData("header");
            this.bodyLayout = this.getFormattedDDFData("body");
        });
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSpeakerConfig(message));
    }

    getFormattedDDFData(expansionStyle) {
        let contentString = this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig[expansionStyle]
            .textConfig.template;
        if (contentString != null) {
            this.ddfData.forEach(function(value, key) {
                if (contentString.indexOf(value.key) > -1) {
                    contentString = contentString.replace(new RegExp(value.key, "g"), value.label);
                }
            });
            return contentString
                .replace(new RegExp('contenteditable="true"', "g"), "")
                .replace(new RegExp("contenteditable='true'", "g"), "");
        } else {
            return "";
        }
    }
    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.speakerConfigObj = this.sharedService.configs[this.sharedService.configTypes.SPEAKER[this.baseUrl]];
        if (this.speakerConfigObj == null || this.speakerConfigObj.id == null) {
            this.speakerConfig = cloneDeep(this.sharedService.speakerLayoutConfig[this.baseUrl]);
            this.speakerConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.SPEAKER[this.baseUrl]
            };
        } else {
            this.speakerConfig = JSON.parse(this.speakerConfigObj.config);
            this.sharedService.speakerLayoutConfig[this.baseUrl] = cloneDeep(this.speakerConfig);
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.speakerConfig);
        this.sharedService.changedData = this.speakerConfig;

        this.fontstyle = {
            color: this.speakerConfig.labelConfig.fontColor,
            "font-style": this.speakerConfig.labelConfig.fontStyle,
            "text-decoration": this.speakerConfig.labelConfig.fontStyle,
            "font-weight": this.speakerConfig.labelConfig.fontStyle,
            "font-size": this.speakerConfig.labelConfig.fontSize + "px",
            "padding-right": "5px"
        };
        // for backward compatibility
        if (this.baseUrl == "general" && this.speakerConfig.catalogConfig.buttonConfig == null) {
            this.speakerConfig.catalogConfig.buttonConfig = this.sharedService.speakerLayoutConfig[
                this.baseUrl
            ].catalogConfig.buttonConfig;
        }

        this.setBasedOnImageNameHelper("header");
        this.setBasedOnImageNameHelper("body");
    }

    private setBasedOnImageNameHelper(property) {
        if (this.speakerConfig.catalogConfig[property].imageConfig.basedOn == "speaker_img") {
            this.basedOnImageName[property] = "Speaker <br/> Profile <br/> Image";
        } else if (this.speakerConfig.catalogConfig[property].imageConfig.basedOn == "dynamic_img") {
            var img = this.speakerConfig.catalogConfig[property].imageConfig.dynamicImage;
            var filename = img.replace(/^.*[\\\/]/, "");
            var encodeFileName = encodeURIComponent(filename);
            var imgURL = img.replace(filename, encodeFileName);
            var imgHeight = this.speakerConfig.catalogConfig[property].imageConfig.height;
            var imgWidth = this.speakerConfig.catalogConfig[property].imageConfig.width;
            if (this.speakerConfig.layout == "l_circular") {
                this.basedOnImageName[property] =
                    "<img style='opacity: .8' alt='Dynamic image uploaded' class='img-border-radius' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            } else if (this.speakerConfig.layout == "l_square") {
                this.basedOnImageName[property] =
                    "<img style='opacity: .8' alt='Dynamic image uploaded' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            }
        } else {
            if (this.sharedService.speakerFileCustomFields != null) {
                this.sharedService.speakerFileCustomFields.forEach((cf) => {
                    if ("custom_" + cf.code == this.speakerConfig.catalogConfig[property].imageConfig.basedOn) {
                        this.basedOnImageName[property] = cf.name;
                    }
                });
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.baseUrl === "highlighted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define General Speaker";
            } else {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define HTML";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-speaker";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-speaker";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveSpeakerConfig(message) {
        if (message.text == "save-speaker-session" || message.text == "save-next-speaker-session") {
            this.speakerConfigObj.config = JSON.stringify(this.speakerConfig);
            this.catalogService.saveSetupConfig(this.speakerConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.speakerConfig);
                this.sharedService.changedData = this.speakerConfig;

                this.speakerConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[
                    this.sharedService.configTypes.SPEAKER[this.baseUrl]
                ] = this.speakerConfigObj;
            });
        } else if (message.text == "apply-speaker-config") {
            // For checking IE borwser
            if(!this.sharedService.isMSIE()) {
            window.dispatchEvent(new Event("resize"));
            }
            this.speakerConfig = cloneDeep(this.sharedService.speakerLayoutConfig[this.baseUrl]);
            // For checking unsaved data
            this.sharedService.changedData = this.speakerConfig;

            this.drawerService.hideDrawer();

            this.setBasedOnImageNameHelper("header");
            this.setBasedOnImageNameHelper("body");

            this.fontstyle = {};
            setTimeout(() => {
                this.fontstyle = {
                    color: this.speakerConfig.labelConfig.fontColor,
                    "font-style": this.speakerConfig.labelConfig.fontStyle,
                    "text-decoration": this.speakerConfig.labelConfig.fontStyle,
                    "font-weight": this.speakerConfig.labelConfig.fontStyle,
                    "font-size": this.speakerConfig.labelConfig.fontSize + "px",
                    "padding-right": "5px"
                };
            }, 0);
            this.headerLayout = this.getFormattedDDFData("header");
            this.bodyLayout = this.getFormattedDDFData("body");
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.speakerLayoutConfig[this.baseUrl] = cloneDeep(this.speakerConfig);
        this.sharedService.expansionStyle = expansionStyle;
        if (item == "template") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Choose a different Template",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/template-config";
        } else if (item == "img") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Dynamic Image",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/image-config";
        } else if (item == "region") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Region",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/region-config";
        } else if (item == "html") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/html-config";
        } else if (item == "label") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Label",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/label-config";
        } else if (item == "button") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Buttons & Icons",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/button-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
